import React, { useEffect } from "react"
import styled from "styled-components"
import ResponsiveLayout from "../../ProjectNonSpecificComponents/Layouts/ResponsiveLayout"
import AdminTemplateLeftPanel from "../Templates/AdminTemplate/AdminTemplateLeftPanel"
import ItemFormSection from "components/ProjectSpecificComponents/Elements/AdminForm/organisms/RequestSections/ItemFormSection"
import NewRequestFormSection from "components/ProjectSpecificComponents/Elements/AdminForm/organisms/RequestSections/NewRequestFormSection"
import CollectionFormSection from "components/ProjectSpecificComponents/Elements/AdminForm/organisms/RequestSections/CollectionFormSection"
import RequestTableFormSection from "components/ProjectSpecificComponents/Elements/AdminForm/organisms/RequestSections/RequestTableFormSection"
import SavedRequestFormSection from "components/ProjectSpecificComponents/Elements/AdminForm/organisms/RequestSections/SavedRequestFormSection"
import MobileSaveButton from "components/ProjectSpecificComponents/Elements/Global/atoms/Buttons/MobileSaveButton"
import Overlay from "components/ProjectNonSpecificComponents/Elements/Overlay/Overlay"
import { useStore } from "components/ProjectSpecificComponents/Contexts/GlobalStoreContext"
import useScreenType from "components/ProjectNonSpecificComponents/Hooks/useScreenType"
import { observer } from "mobx-react"
import { ADMIN_PANEL_FORM_IDS } from "../Constants/ADMIN_PANEL_CONSTANTS"
import EmailFormSection from "../Elements/AdminForm/organisms/RequestSections/EmailFormSection"
import { useFormStore } from "../Contexts/FormStoreContext"
import { Redirect } from "react-router"
import ROUTES from "../Constants/ROUTES"
import { useHistory } from "react-router-dom"
import useBrowserBtn from "components/ProjectNonSpecificComponents/Hooks/useBrowserBtn"
import { useTranslation } from "react-i18next"

export const FormConfigurationPage = observer(() => {
	const store = useStore()
	const { instanceAnonymousUsers } = store

	const formStore = useFormStore()
	const { isMobile } = useScreenType()
	const { t } = useTranslation()
	const history = useHistory()
	//If connection failed or no config is selected return to config table
	if (!formStore.selectedFormsConfig || !store.hasConnectionBeenMade) {
		return <Redirect to={ROUTES.REQUEST_CNFG} />
	}

	const _onBackBtnClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		store.setInfoModalConfig({
			type: "warning",
			titleKey: "",
			descriptionKey: t("rawText.save-all-changes"),
			proceedTextKey: t("rawText.back"),
			onProceed: () => {
				formStore.setSelectedConfigFormBeforeEdit()
				store.resetInfoModalConfig()
			},
		})
	}

	const canCompereJSONs = () => {
		// If item type ID is known then wait for field info from API
		if (
			formStore.selectedFormsConfig?.itemType?.id &&
			formStore.mainFieldsData &&
			formStore.mainFieldsData?.length > 0
		) {
			return !formStore.checkIfFormIsEdited()
		}
		return false
	}

	useBrowserBtn(
		canCompereJSONs(),
		_onBackBtnClick,
		[formStore.selectedFormsConfig],
		ROUTES.REQUEST_CNFG
	)

	return (
		<>
			<ResponsiveLayout
				leftPanel={<AdminTemplateLeftPanel type="REQUEST" />}
				tabletSidebar={<AdminTemplateLeftPanel type="REQUEST" />}
			>
				<ConfigContainer id="section-container">
					<ItemFormSection id={ADMIN_PANEL_FORM_IDS.item} />
					{store.showAdminPanelForms && (
						<>
							<CollectionFormSection id={ADMIN_PANEL_FORM_IDS.collection} />
							<NewRequestFormSection id={ADMIN_PANEL_FORM_IDS.newRequestForm} />
							{!instanceAnonymousUsers && (
								<RequestTableFormSection id={ADMIN_PANEL_FORM_IDS.requestTableForm} />
							)}
							{!instanceAnonymousUsers && (
								<SavedRequestFormSection id={ADMIN_PANEL_FORM_IDS.savedRequestForm} />
							)}
							{/* <EmailFormSection id={ADMIN_PANEL_FORM_IDS.email} /> */}
						</>
					)}
				</ConfigContainer>
			</ResponsiveLayout>
			{isMobile && (
				<Overlay bottom={16} right={16}>
					<MobileSaveButton />
				</Overlay>
			)}
		</>
	)
})

export default FormConfigurationPage

export const ConfigContainer = styled.div`
	width: -webkit-fill-available;
	max-width: 100%;
	overflow: hidden auto;
	height: 100%;
`
